import { useEffect, useState } from 'react'
import { translations } from '../i18n/translations'

export function useLanguage() {
  const [language, setLanguage] = useState(
    localStorage.getItem('app-language') || 'es'
  )

  useEffect(() => {
    function handleLanguageChange(e) {
      setLanguage(e.detail)
    }
    window.addEventListener('languageChange', handleLanguageChange)
    return () => window.removeEventListener('languageChange', handleLanguageChange)
  }, [])

  function t(key, vars) {
    let text = translations[language]?.[key] || translations['es']?.[key] || key

    if (vars) {
      Object.keys(vars).forEach((varKey) => {
        text = text.replace(`{${varKey}}`, vars[varKey])
      })
    }

    return text
  }

  return { language, t }
}